
<div id="pageSansMenu" class="d-flex flex-column main-sans-menu">
  <vue-headful
    :title="metaData.title"
    :description="metaData.description"
    :keywords="metaData.keywords"
    :image="metaData.metaOGImage"
    :url="metaUrl"
    :head="{
      'meta[name=robots]': { content: metaData.metaNoIndex },
      'link[hreflang=en-ca]': { href: pathAnglais },
      'link[hreflang=fr-ca]': { href: pathFrancais },
      'link[rel=apple-touch-icon]': { type: 'image/png' },
      'link[rel=icon]': { type: 'image/png' },
    }"
  />

  <div class="w-100 h-100">
    <main class="d-flex align-items-center h-100 px-0 overflow-hidden">
      <EditableArea v-if="content.main" class="w-100 h-100" :content="content.main" />
    </main>
  </div>
</div>
